export default (state, actions) => {
  return Object.assign({}, state, { flag: actions.flag });
};
